const tokenManager = (() => {
  let token = localStorage.getItem('api_token');
  let refreshToken = localStorage.getItem('refresh_token');
  let isRefreshing = false;
  let refreshQueue = [];

  const initializeTokens = () => {
    if (!token || !refreshToken) {
      console.warn('Tokens not found, need to log in again.');
      return;
    }
  };

  const refreshTokenFunction = async (currentToken, currentRefreshToken) => {
    const url = '/api/users/token/refresh';
    const body = { token: currentToken, refreshToken: currentRefreshToken };
    console.log('Attempting to refresh token with:', body);

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`HTTP error! Status: ${response.status}, Details: ${errorText}`);
        throw new Error(`HTTP error! Status: ${response.status}, Details: ${errorText}`);
      }

      const data = await response.json();
      console.log('Token refreshed successfully:', data);
      return data;
    } catch (error) {
      console.error('Failed to refresh token:', error);
      throw error;
    }
  };

  return {
    initializeTokens,
    getToken: () => token,
    getRefreshToken: () => refreshToken,
    setTokens: (newToken, newRefreshToken) => {
      console.log('Updating tokens:', newToken, newRefreshToken);
      token = newToken;
      refreshToken = newRefreshToken;
      localStorage.setItem('api_token', newToken);
      localStorage.setItem('refresh_token', newRefreshToken);
    },
    refreshTokens: async () => {
      if (isRefreshing) {
        return new Promise((resolve) => refreshQueue.push(resolve));
      }
      isRefreshing = true;

      try {
        const newTokens = await refreshTokenFunction(token, refreshToken);
        tokenManager.setTokens(newTokens.token, newTokens.refreshToken);
        refreshQueue.forEach((resolve) => resolve(newTokens.token));
        return newTokens.token;
      } catch (error) {
        console.error('Failed to refresh token:', error);
        throw error;
      } finally {
        isRefreshing = false;
        refreshQueue = [];
      }
    },
  };
})();

async function fetchWithToken(url, options = {}) {
  options.headers = {
    ...options.headers,
    'Authorization': `Bearer ${tokenManager.getToken()}`,
    'Content-Type': 'application/json',
  };

  const executeRequest = async () => {
    console.log('Executing request to:', url, options);
    const response = await fetch(url, options);

    // ВАЖНО: НЕ кидаем ошибку здесь
    return response;
  };

  try {
    const response = await executeRequest();

    if (response.status !== 401) {
      return response;
    }

    // 401 → пробуем обновить токен
    console.warn('Token expired, trying to refresh...');
    const newToken = await tokenManager.refreshTokens();
    options.headers['Authorization'] = `Bearer ${newToken}`;

    return await executeRequest();
  } catch (err) {
    console.error("fetchWithToken fatal error:", err);
    throw err; // это сеть/браузер, не ответ сервера
  }
}


tokenManager.initializeTokens();

export { fetchWithToken, tokenManager };
